import {usePage} from "@inertiajs/vue3";

export default function (value) {
  const {props} = usePage();
  return props.thirdPartys?.includes(value) ?? false;
}
